import Icon from 'veui/components/Icon'
import { IconSearchHistory } from 'dls-icons-vue'

Icon.register('search-history', IconSearchHistory)
